import { render, staticRenderFns } from "./ComplaintDamageList.vue?vue&type=template&id=56f1fcc8&scoped=true"
import script from "./ComplaintDamageList.vue?vue&type=script&lang=js"
export * from "./ComplaintDamageList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDamageList.vue?vue&type=style&index=0&id=56f1fcc8&prod&lang=scss"
import style1 from "./ComplaintDamageList.vue?vue&type=style&index=1&id=56f1fcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1fcc8",
  null
  
)

export default component.exports